export default __webpack_public_path__ + "src/images/slider/42d8b1bb0c09278679093c917145330c-glass-pool.jpg";